import { render, staticRenderFns } from "./Wordlist.vue?vue&type=template&id=ad7b7e9e"
import script from "./Wordlist.vue?vue&type=script&lang=js"
export * from "./Wordlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports